"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _context = require("../TinymceEditor/context");
var _reactDom = require("react-dom");
var _reactI18next = require("react-i18next");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DragContainer = function DragContainer(_ref) {
  var headerRef = _ref.headerRef,
    bottomRef = _ref.bottomRef;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    style = _useState2[0],
    setStyle = _useState2[1];

  // Calculate position
  (0, _react.useEffect)(function () {
    var header = headerRef.current;
    var bottom = bottomRef.current;
    var headerRect = header.getBoundingClientRect();
    var bottomRect = bottom.getBoundingClientRect();
    setStyle({
      top: headerRect.bottom,
      left: headerRect.left,
      width: headerRect.width,
      height: bottomRect.top - headerRect.bottom,
      position: 'absolute',
      zIndex: 100000
    });
  }, []);
  var dragContainer = /*#__PURE__*/_react["default"].createElement("div", {
    style: style,
    className: "pointer-events-none"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-10 inset-0 bg-secondary h-full flex items-center justify-center border-dashed border-2 border-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('drop-files.png'),
    alt: "drop files",
    width: 70,
    height: 70
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary text-sm"
  }, t("compose.dropFile")))));
  return /*#__PURE__*/(0, _reactDom.createPortal)(dragContainer, document.body);
};
var _default = exports["default"] = function _default(_ref2) {
  var headerRef = _ref2.headerRef,
    bottomRef = _ref2.bottomRef;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    dragOver = _useState4[0],
    setDragOver = _useState4[1];
  var editor = (0, _context.useEditor)();
  var isValidDragElement = function isValidDragElement(event) {
    var types = event.dataTransfer.types;
    return !types.some(function (type) {
      return type === 'text/plain' || type === 'text/html';
    });
  };
  (0, _react.useEffect)(function () {
    if (!editor) return;
    var handleEditorDragOver = function handleEditorDragOver(event) {
      isValidDragElement(event) && setDragOver(true);
    };
    var handleEditorDrop = function handleEditorDrop(event) {
      setDragOver(false);
    };
    editor.on('dragover', handleEditorDragOver);
    editor.on('drop', handleEditorDrop);
    editor.getDoc().addEventListener('dragleave', function () {
      setDragOver(false);
    });
  }, [editor]);
  return dragOver && /*#__PURE__*/_react["default"].createElement(DragContainer, {
    headerRef: headerRef,
    bottomRef: bottomRef
  });
};
//# sourceMappingURL=ComposeBodyDropZone.js.map